export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/data/ref/query/get_wage',
      method: 'GET'
    }]
  }
}